import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-progress-spinner',
  templateUrl: './progress-spinner.component.html',
  styleUrls: ['./progress-spinner.component.scss'],
  host: {
    '[class]': 'classes',
    '[style.width.px]': 'diameter',
    '[style.height.px]': 'diameter',
    role: 'progressbar',
    '[attr.aria-label]': 'ariaLabel',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressSpinnerComponent {
  @Input() ariaLabel = 'Carregando';
  @Input() diameter = 32;
  @Input() color: 'primary' | 'accent' | 'warn' = 'primary';
  @Input() strokeWidth: number | undefined;

  get classes(): string {
    const classList: string[] = ['progress-spinner'];
    classList.push(`progress-spinner--${this.color}`);
    return classList.join(' ');
  }

  get resolvedStrokeWidth(): number {
    return this.strokeWidth ?? 10;
  }

  get circleRadius(): number {
    return (100 - this.resolvedStrokeWidth) / 2;
  }
}
